import { render, staticRenderFns } from "./FileuploadProps.vue?vue&type=template&id=d08aaa4a"
import script from "./FileuploadProps.vue?vue&type=script&lang=js"
export * from "./FileuploadProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports